<button class="cart-action-button-share btn-icon text-b3-s-300 color-black" (click)="handleClick()">
  <sd-icon [type]="iconTypes.SHARE" class="icon-size-m icon-size-lg-s"></sd-icon>
  @if (!isTabletMdDown()) {
    <span>поделиться</span>
  }
</button>
